<template>
    <div id="header_bgColor" style="width:100%;background-color:#fff;">
        <div class="header">
            <div class="title">
                <img src="../../assets/img/images/logo.png" alt="" />
                <div class="title_info">
                    <div class="compName">北京普发动力控股股份有限公司</div>
                    <div class="compEng">BEIJING PROVA ENERGY HOLDING CO., LTD</div>
                </div>
                <div class="title_info cursors" @click="goToExternalLink">
                    <div class="compName" style="letter-spacing: 2px;font-size:26px;">SYNERGY</div>
                    <div class="compEng" style="font-size:14px;">普发动力意大利全资子公司</div>
                </div>
            </div>
            <div class="header-right">
                <div class="nav">
                    <el-menu :default-active="onRoutes" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item v-for="item in headerMenus"  :key="item.menuId"
                            :index="item.type"
                            :disabled="drawer"
                            @mouseenter.native="handleMouseEnter(item)"
                            @mouseleave.native="handleMouseLeave()"
                        >
                            {{item.guideZw}}
                            
                        </el-menu-item>
                    </el-menu>
                </div>
                <div class="contactNum">
                    <!-- <img src="../../assets/img/images/phone_icon.png" alt="" /> -->
                    <div class="num">
                        <div class="numName">{{serviceHotline}}：010-81215833</div>
                        <!-- <div class="numPhone"></div> -->
                    </div>
                    <div class="language_box">
                        <span @click="languageTap(1)" :class="checked1">中文</span>
                        <span @click="languageTap(2)" :class="checked2">English</span>
                        <span @click="languageTap(3)" :class="checked3">русский язык</span>
                    </div>
                </div>
            </div>
        </div>
        
        <transition name="bounce-in">
            <div class="draw_boxs" v-show="drawer" @mouseenter="handleMouseEnters" @mouseleave="handleMouseLeaves">
                <div class="nav_draw">
                    <div class="nav_draw_box" v-for="item in headerMenus_child"  :key="item.menuId">
                        <div class="title"  @click="gotoviews(item)">{{item.guideZw}}</div>
                        <!-- <div class="sub_box">
                            <div class="subtitle" v-for="ite in item.children"  :key="ite.menuId" @click="gotoviews(item,ite)">{{ite.guideZw}}</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { gwGetMenuList } from '@/api/index';
export default {
    data() {
        return {
            languageType: '1',
            drawer: false,
            checked1: '',
            checked2: '',
            checked3: '',
            headerMenus:[],
            headerMenus_child:[],
            serviceHotline:''
        };
    },
    methods: {
        goToExternalLink() {
            const externalUrl = 'https://synergy-for-gas.com';
            window.location.href = externalUrl;
            },
        gotoviews(e){
            if(e.type === 'product'){
                this.$router.push({
                    path: '/businessArea/product',
                    query: { params: e.order }
                    // query: { 
                    //     params: e ,
                    //     order:e.order
                    // }
                });
            }
            if(e.type === 'operation'){
                this.$router.push({
                    path: '/businessArea/operation',
                    query: { 
                        params: e ,
                        order:e.order
                    }
                });
            }
        },
        handleMouseEnter(e) {
            if(e.children.length > 0){
                this.headerMenus_child = e.children;
                this.drawer = true;
            }else{
                this.drawer = false;
            }
        },
        handleMouseLeave() {
            this.drawer = false;
        },
        handleMouseEnters() {
            this.drawer = true;
        },
        handleMouseLeaves() {
            this.drawer = false;
        },
        handleSelect(key, keyPath) {
            this.$router.push('/' + keyPath);
            // sessionStorage.clear();
        },
        languageTap(e) {
            //清除所有本地缓存
            // localStorage.clear();
            if (e == 1) {
                this.resetSetItem('languageType', 1);
            } else if (e == 2) {
                this.resetSetItem('languageType', 2);
            } else if (e == 3) {
                this.resetSetItem('languageType', 3);
                // localStorage.setItem('languageType', 3);
            }
        },
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then(res => {
                // console.log('导航加载tree参数必填语言',res.obj)
                this.headerMenus = res.obj.menuList,
                this.headerMenus_child=res.obj.menuList[1].children,
                this.serviceHotline =res.obj.serviceHotline;
            });
        }
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetMenuList();
        if (this.languageType == 1) {
            this.checked1 = 'checked';
            this.checked2 = '';
            this.checked3 = '';
        } else if (this.languageType == 2) {
            this.checked2 = 'checked';
            this.checked1 = '';
            this.checked3 = '';
        } else {
            this.checked3 = 'checked';
            this.checked1 = '';
            this.checked2 = '';
        }
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.gwGetMenuList();
            if (this.languageType == 1) {
                this.checked1 = 'checked';
                this.checked2 = '';
                this.checked3 = '';
            } else if (this.languageType == 2) {
                this.checked2 = 'checked';
                this.checked1 = '';
                this.checked3 = '';
            } else {
                this.checked3 = 'checked';
                this.checked1 = '';
                this.checked2 = '';
            }
        });
    },
    computed: {
        onRoutes() {
            if(this.$route.meta.title == '工程案例'){
                return 'operation';
            }else if(this.$route.meta.title == '产品中心'){
                return 'product';
            }else{
                return this.$route.path.replace('/', '');
            }
        }
    }
};
</script>
<style scoped lang="less">
@deep: ~'>>>';
.header{
  @media screen and (max-width:1700px) {
    // justify-content: space-evenly;
    padding:15px;
  }
  @media screen and (min-width:1701px) {
    padding:0 5%;
    // justify-content: space-between;
  }
}
.header {
    
    justify-content: space-evenly;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1.5px solid #e6e6e6;
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 999;
    background-color: #fff;
    color: #023e7a;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .title {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 42px;
        }
        .title_info {
            width: 350px;
            font-family: cursive;
            margin-left: 10px;
            font-size: 24px;
            font-weight: bold;
            .compEng {
                font-size: 18px;
                font-family: monospace;
            }
        }
        .cursors{
            width:205px;height:60px;text-align:center;border:2px solid #2f5597;border-radius:10px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            align-content: center;
        }
        .cursors:hover{
            cursor: pointer;
            color:#9f0505;
            border:2px solid #9f0505;
        }
    }
    .language_box span{margin-right:30px;}
    .header-right {
        display: flex;
        align-items: center;
        position: relative;
        .contactNum {
            width: 310px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            flex-wrap: wrap;
            margin-top: 20px;
            position: relative;
            img {
                width: 35px;
                height: 35px;
            }
            .num {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                margin-left: 5px;
            }
            .language_box {
                // position: absolute;
                font-size: 12px;
                top: -8px;
                right: 18px;
                color: #000;
                span {
                    margin: 0 8px;
                }
                span:hover {
                    color: #9f0505;
                    cursor: pointer;
                }
            }
        }
    }
}

.header .el-menu-item {
    cursor: pointer;
    font-size: 1em;
}
.el-menu.el-menu--horizontal {
    border: none;
}
.el-menu--horizontal > .el-menu-item {
    color: #333333;
    height: 75px;
    line-height: 81px;
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #023e7a;
    color: #023e7a;
    background-color: rgba(255, 255, 255, 0) !important;
}
.el-menu--horizontal > .el-menu-item.is-disabled:hover,
.el-menu-item:hover {
    border-color: transparent;
    border-bottom: 2px solid #023e7a !important;
    color: #023e7a !important;
    background-color: rgba(255, 255, 255, 0) !important;
}

.draw_boxs {
    width:100%;
    background: rgba(2, 62, 122, 0.8) !important;
    // background-color: #eeeeee;
    position: absolute;
    left:0;
    z-index: 999;
    top: 77.99999px;
    height:60px;
    .nav_draw {
        display: flex;
        width: 50%;
        margin: auto;
        .nav_draw_box {
            width: 50%;
            margin-top:12px;
            .title {
                text-align: center;
                font-size: 18px;
                height: 36px;
                line-height: 36px;
                padding: 0 15px;
                box-sizing: border-box;
                // padding-bottom: 10px;
                color: #fff;
                position: absolute;
                cursor: default;
            }
            .title:hover{
                border-bottom: 2px solid #d4d4d4;
            }
            .sub_box {
                position: relative;
                top: 50px;
                left: 0;
            }
            .subtitle {
                width: 50%;
                font-size: 16px;
                font-weight: 600;
                line-height: 22px;
                margin: 15px 0;
                color: #fff;
                text-decoration: none;
                // border-bottom: 1px solid #fff;
            }
            .subtitle:hover {
                // border-bottom: 1px solid #023e7a;
                cursor: pointer;
                font-weight: bold;
                color: rgb(255, 208, 75);
            }
        }
    }
}

@{deep}.el-menu-item.is-disabled {
    opacity: 1;
}
.checked {
    color: #9f0505;
}
// 顶部导航展开动画
.bounce-in-enter-active {
    transition: all 0.3s ease;
    transition-delay: 0.2s;
}
.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.bounce-in-enter,
.bounce-in-leave-to {
    transform: translateX(-100px);
    opacity: 0;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.5);
    }

    100% {
        transform: scale(1);
    }
}

</style>
